import { render } from "./ChartsFontStyleConfiger.vue?vue&type=template&id=c2e31c06&scoped=true"
import script from "./ChartsFontStyleConfiger.vue?vue&type=script&lang=js"
export * from "./ChartsFontStyleConfiger.vue?vue&type=script&lang=js"

import "./ChartsFontStyleConfiger.vue?vue&type=style&index=0&id=c2e31c06&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2e31c06"]])

export default __exports__